import { UpdateWatchListInput } from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

export const getWatchlist = async () => {
  try {
    const response = await axiosClient.get("/servicedesk/watchlist");
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

export const removeWatchListItem = async ({
  serviceId,
  serviceType,
}: UpdateWatchListInput) => {
  try {
    const response = await axiosClient.patch(
      `/servicedesk/watchlist/${serviceType}/${serviceId}`
    );
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (e: any) {
    apiErrorHandler(e);
  }
};

export const addWatchListItem = async ({
  serviceId,
  serviceType,
}: UpdateWatchListInput) => {
  try {
    const response = await axiosClient.post(
      `/servicedesk/watchlist/${serviceType}/${serviceId}`
    );
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (e: any) {
    apiErrorHandler(e);
  }
};
